var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "question-wrapper d-flex flex-column justify-content-between"
    },
    [
      _c("div", { staticClass: "question-header text-center" }, [
        _c("h3", [_vm._v(_vm._s(_vm.question.text))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "question-answers" },
        _vm._l(_vm.question.answers, function(answer, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "question-answer text-center",
              class: {
                active:
                  _vm.selectedAnswer && _vm.selectedAnswer.id === answer.id
              },
              on: {
                click: function($event) {
                  return _vm.selectAnswer(answer)
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(answer.text))])]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }